import React from "react"
import { get } from "lodash"
import Links from "./Links"

const LinksBlock = ({ alignText, block, contrastText }) => {
  const links = get(block, "elements.links.value")
  const align = get(block, "elements.align.value[0].codename")||alignText

  return (
    <Links align={align} links={links} contrastText={contrastText} />
  )
}

export default LinksBlock